<template>
<div>
   <!-- ___________main-tables    -->
            <div class="main-tables mobileTbl table-responsive p-1" >
                    <table class="table table-hover mb-0 loading" cellspacing="0" >
                         <thead style="text-aligin:center;"  :class="{ 'is-fixed': isFixed }">
                            <tr>
                                <th class="th-header"  v-for="key in initFieldData" v-bind:key="key.title"
                                    v-bind:class="{'is-collapsed' : ! key.status }"> 
                                    <a href="#" v-on:click="sortTable(key.id)">
                                        {{ $t('table.'+ key.id)}}</a>
                                    <span class="arrow" :class="key.id  > 0 ? 'asc' : 'dsc'"></span>
                                </th>
                            </tr>
                        </thead>                                                     
                         <tbody class="table100-body js-pscroll">
                 <tr  v-for="key in dataFieldsComponent" v-bind:key="key.num">
                    <td  v-for="ids in initFieldData" v-bind:ids="ids.title"
                         v-bind:class="{'is-collapsed' : ! ids.status  }" :data-title="$t('table.'+ key.id)">
                       
                        <div v-if="ids.id === 'order'">
                         <p>{{key[ids.id] }}</p>
                         <a href="#" class="link primary"  
                            v-on:click="nextTablesOrderByPallet(key[ids.id])" >{{ $t('link.warrant-pallets')}}</a>
                        </div>    
                       
                        <a v-if="ids.id === 'orderForProduction'"
                            href="#"  
                            v-on:click="nextTablesTranscriptOrder(key[ids.id])" class="link primary">{{key[ids.id] }} </a>

                         <p v-if="ids.id != 'order' && ids.id != 'orderForProduction' ">{{key[ids.id] }}</p>
                         
                    </td>
                 </tr>
             </tbody>
                    </table>



            </div>
            <!-- ____________________and main tables -->
   







   
</div>    
</template>

<script>
export default {
  props: {
    dataFields: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      filds: [],
      dataFieldsComponent: [],
      sortFields: {},
      colums: {},
      sortOrderBy: 0,
      keysearch: "",
      filterfield: true,
      isFixed: false
    };
  },
  created() {},

  computed: {
    initFieldData: function() {
      var headers = this.dataFields.length
        ? Object.keys(this.dataFields[0])
        : [];
      var customs = [];
      var sort = [];
      var columsselect = [];
      headers.forEach(function(item, i, arr) {
        customs.push({ id: item, tip: item, title: item, status: true });
        sort[item] = 0;
        columsselect[item] = true;
      });
      this.filds = customs;
      this.sortFields = sort;
      this.colums = columsselect;
      this.dataFieldsComponent = this.dataFields;

      return this.filds;
    }
  },

  methods: {
    //sorting fields table
    sortTable: function(sortKey) {
      if (this.sortFields[sortKey] == 0) {
        console.log("Зростання");
        this.sortOrderBy = 1;
        this.sortFields[sortKey] = 1;
        this.dataFieldsComponent = this.dataFieldsComponent
          .slice()
          .sort(function(a, b) {
            a = a[sortKey];
            b = b[sortKey];
            if (a > b) return -1;
            if (a < b) return 1;
            return 0;
          });
      } else if (this.sortFields[sortKey] == 1) {
        console.log("Спадання");
        this.sortOrderBy = 0;
        this.sortFields[sortKey] = 0;
        this.dataFieldsComponent = this.dataFieldsComponent
          .slice()
          .sort(function(a, b) {
            a = a[sortKey];
            b = b[sortKey];
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          });
      }
    },
    nextTablesOrderByPallet: function(id) {
      this.$emit("hrefclickOrderByPallet", id);
    },

    nextTablesTranscriptOrder: function(id) {
      this.$emit("hrefclickTranscriptOrder", id);
    }
  }
};
</script>
<style scoped>
/* tables-scroll */
.table-scroll {
  position: relative;
  width:100%;
  z-index: 1;
  margin: auto;
  overflow: auto;
  height: 600px;
}
.table-scroll table {
  width: 100%;
  min-width: 1280px;
  margin: auto;
  border-collapse: separate;
  border-spacing: 0;
}
.table-wrap {
  position: relative;
}
.table-scroll th,
.table-scroll td {
  padding: 5px 10px;
  border: 1px solid rgb(223, 211, 211);
  background: #fff;
  border-bottom: 2px solid #e3ebf3;
    border-top: 1px solid #e3ebf3;
  vertical-align: top;
}
#table-scroll thead th {
  background: rgb(226, 222, 222);
  color: #fff;
  border-bottom: 2px solid #e3ebf3;
    border-top: 1px solid #e3ebf3;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  padding-bottom: 20px;
}
/* safari and ios need the tfoot itself to be position:sticky also */
.table-scroll tfoot,
.table-scroll tfoot th,
.table-scroll tfoot td {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  background: #666;
  color: #fff;
  z-index:4;
}


.table-scroll
th:first-child {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  z-index: 2;
  background: #ccc;
}
#table-scroll tbody tr td:first-child {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  z-index: 2;
  background: rgb(235, 230, 230);
}
.table-scroll thead th:first-child,
.table-scroll tfoot th:first-child {
  z-index: 5;
}
#table-scroll .condition {
  background-color: #f38682;
}
.arrow {
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 0;
    margin-left: 5px;
    opacity: 0.9;
    }
.arrow.dsc {
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #fff;
}
.arrow.asc {
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #fff;
}

@media (max-width: 730px) {
  .table-scroll {  
  height: 300px;
}
    }

/* and tables */
</style>


// WEBPACK FOOTER //
// src/components/table.vue